"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.importableComponentInfoSchema = exports.importArtifactUidSchema = exports.optionalString = void 0;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
/**
 * Schemas/functions shared across all jobs
 */
exports.optionalString = zod_1.default.preprocess((v) => v ?? undefined, zod_1.default.string().optional());
exports.importArtifactUidSchema = zod_1.default.custom((value) => typeof value === "string" &&
    (value.startsWith("pdf-upload-") || value.startsWith("excel-upload") || value.startsWith("pdf")));
/**
 * Represents one component extracted from datasheet, and we will feed this to
 * the importComponentsFromDatasheet job
 */
exports.importableComponentInfoSchema = zod_1.default.object({
    packageFamily: zod_1.default.string().nullish(),
    partNumber: zod_1.default.string(),
    pinCount: zod_1.default.number(),
});
//# sourceMappingURL=shared.js.map